// extracted by mini-css-extract-plugin
export default {"label":"label§XlPaBlEDH921LWGPFNye"};